import './footer.css'

const Footer = () => {
  return (
    <footer className='footer'>
      <span>Jonathan Zhou · New York City</span>
      <a className='footer__email' href='mailto:jonathanzhou77@gmail.com'>jonathanzhou77@gmail.com</a>
    </footer>
  )
}

export default Footer
